import { ActivitiesFiltersParams, TrackingActivity } from '@recruitee/http-types';

export enum EntityStoreKey {
  activitySubscriptions = 'activitySubscriptions',
  activitySubscriptionsPerRole = 'activitySubscriptionsPerRole',
  notifications = 'notifications',
  trackingActivities = 'trackingActivities',
  notificationsCounter = 'notificationsCounter',
  notificationsCounterFiltered = 'notificationsCounterFiltered',
}

export type NotificationsStore = {
  activities: TrackingActivity[];
};

export interface TrackingActivitiesStore {
  activities: TrackingActivity[];
}
export interface NotificationCounterStore {
  unreadCount: number;
}
export interface NotificationCounterFilteredStore {
  unreadCount: number;
}

export type TrackingActivitiesFiltersParams = {
  offerId?: number;
  requisitionId?: number;
  candidateId?: number | null;
  filters?: ActivitiesFiltersParams;
};

export const ActivitiesDefaultLimit = 20;

export enum ActivitiesDataScope {
  All = 'all',
  AllUnread = 'allUnread',
  Candidate = 'candidate',
  Offer = 'offer',
  Dropdown = 'dropdown',
  DropdownUnread = 'dropdownUnread',
  Requisition = 'requisition',
}

export const NotificationShowAllFlagKey = 'notification_show_all_flag';
